import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

/**
 * The Hint component is used for triggering all kinds of tiny user interactions
 * like showing a tooltip or linking to a footnote.
 * @see https://bronson.vwfs.tools/default/components/detail/bronson-hint.html
 *
 * @param {string} [className] - Additional class to apply on the component element.
 * @param {React.ReactNode|string} [children] - The content to display inside the hint.
 * @param {string} [testId] - `[data-testid]` attribute on the component element.
 * @param {Object} [otherProps] - Other props to be passed to the component element.
 * @returns {JSX.Element} - The {@link Hint} component.
 * @constructor
 */
export function Hint({ className, children, testId, ...otherProps }) {
  const classNameList = classNames('c-hint', className).trim()
  return (
    <sup className={classNameList} data-testid={testId} {...otherProps}>
      {children}
    </sup>
  )
}

Hint.propTypes = {
  className: PropTypes.string,
  /**
   * Allow one node child or a string.
   */
  children: PropTypes.oneOfType([PropTypes.element.isRequired, PropTypes.string.isRequired]),
}
